import React, { useState } from "react";

export const NavigationTabs = ({
  tabs,
  activeTab,
  setActiveTab,
  searchText,
  setSearchText,
  filterType,
  setFilterType,
}) => {
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div>
      <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
        {tabs.map((tab, index) => (
          <li className="nav-item" key={index}>
            <button
              className={`nav-link ${activeTab === index ? "active" : ""} ${
                tab.disabled ? "disabled" : ""
              }`}
              onClick={() => handleTabClick(index)}
            >
              <span>{tab.text}</span>
            </button>
          </li>
        ))}

        {/* Dropdown + Search input */}
        <div className="ms-auto d-flex align-items-center">
          <div className="input-group" style={{ width: "300px" }}>
            <select
              className="form-select custom-select1"
              style={{ maxWidth: "80px" }}
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
            >
              <option value="R">R</option>
              <option value="ES">ES</option>
            </select>
            <input
              type="text"
              className="form-control"
              placeholder="Search by Receipt/Expense No"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>
      </ul>
      <div>{tabs[activeTab].content}</div>
    </div>
  );
};
